module.exports = __webpack_public_path__ + "img/Unidad12-4.2c588ffa.png";